import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "Components/ui/card";
import { Badge } from "Components/ui/badge";
import { PackageSearch } from "lucide-react";

export default function InventoryAlertsPanel({ data }) {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle style={{ fontSize: "16px" }}>Inventory Alerts</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="d-flex flex-column align-items-center justify-content-center py-5" style={{ color: "#8A9BA8" }}>
            <PackageSearch size={40} strokeWidth={1.5} />
            <p style={{ fontFamily: "tt-regular", fontSize: "14px", marginTop: "12px" }}>
              Inventory tracking coming soon
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  const getStatusBadge = (quantity) => {
    if (quantity <= 5) return <Badge variant="danger">Critical</Badge>;
    if (quantity <= 20) return <Badge variant="warning">Low</Badge>;
    return <Badge variant="success">OK</Badge>;
  };

  const sorted = [...data].sort((a, b) => (a.quantity ?? 0) - (b.quantity ?? 0));

  return (
    <Card>
      <CardHeader className="d-flex flex-row align-items-center justify-content-between">
        <CardTitle style={{ fontSize: "16px" }}>Inventory Alerts</CardTitle>
        <a href="/product" style={{ fontSize: "13px", color: "#4B7A8E", fontFamily: "tt-regular", textDecoration: "none" }}>View All</a>
      </CardHeader>
      <CardContent className="p-0">
        <table style={{ width: "100%", fontSize: "14px", fontFamily: "tt-regular" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #EAEFEF" }}>
              <th style={{ padding: "8px 16px", color: "#8A9BA8", fontFamily: "Aenoik-medium", fontSize: "11px", textTransform: "uppercase" }}>Product</th>
              <th style={{ padding: "8px 16px", color: "#8A9BA8", fontFamily: "Aenoik-medium", fontSize: "11px", textTransform: "uppercase", textAlign: "right" }}>Stock</th>
              <th style={{ padding: "8px 16px", color: "#8A9BA8", fontFamily: "Aenoik-medium", fontSize: "11px", textTransform: "uppercase", textAlign: "right" }}>Status</th>
            </tr>
          </thead>
          <tbody>
            {sorted.slice(0, 8).map((item, i) => (
              <tr key={i} style={{ borderBottom: "1px solid #EAEFEF" }}>
                <td style={{ padding: "10px 16px", color: "#25343F" }}>{item.name}</td>
                <td style={{ padding: "10px 16px", textAlign: "right", color: "#25343F" }}>{item.quantity}</td>
                <td style={{ padding: "10px 16px", textAlign: "right" }}>{getStatusBadge(item.quantity)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}
